import inquirer from "inquirer"
import { SetupContext } from "./flow/types.js"
import { colorize } from "./ui.js"

export async function promptConfirmation(messageText: string, options?: { defaultValue?: boolean }): Promise<boolean> {
  const response = await inquirer.prompt<{ confirmed: boolean }>([
    {
      default: options?.defaultValue ?? true,
      message: colorize(messageText, "blue"),
      name: "confirmed",
      type: "confirm",
    },
  ])

  return response.confirmed
}

export function resolvePromptText(preset: SetupContext["selectedPromptPreset"], customPrompt?: string): string {
  if (preset === "Custom") return customPrompt ?? ""

  return "Create a component gallery using our design system that showcases core components and key states so we can quickly validate component understanding."
}
